export default __webpack_public_path__ + "static/media/536.37f3344d.jpg";